import React, { Component, PropTypes } from 'react';
import { FlatButton } from 'material-ui';

class FlatButtonWithLoader extends Component {

  render() {
    const { loader, style, ...extra } = this.props;
    const combinedStyle = Object.assign({}, style);
    if (loader) return <FlatButton className="signin-button loader" label="..." {...extra} disabled style={combinedStyle} />;
    return <FlatButton {...extra} style={combinedStyle}/>;
  }
}

FlatButtonWithLoader.propTypes = {
  loader: PropTypes.any,
  style: PropTypes.object,
};

export default FlatButtonWithLoader;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/flat-button-with-loader.jsx